import { atom } from "recoil";

export const deviceIdState = atom<string | undefined>({
  key: "deviceIdState",
  default: undefined,
});
